export default __webpack_public_path__ + "static/media/scheduled.0517b34f.png";